module.exports = __webpack_public_path__ + "static/media/1-2-alzbetu-navstivila.b5e2a80d.jpg";